<template>
  <div v-if="userClubs.length > 0" class="py-3">
    <div class="flex justify-between items-center mb-2">
      <label class="text-sm font-medium text-gray-400">Share to Club</label>
      <button
        v-if="modelValue"
        class="text-xs text-gray-500 hover:text-gray-300"
        @click="$emit('update:modelValue', null)">
        Clear
      </button>
    </div>

    <div class="space-y-2">
      <!-- No club selected option -->
      <button
        type="button"
        :class="[
          'w-full flex items-center gap-3 p-3 rounded-lg border transition-colors text-left',
          !modelValue
            ? 'bg-purple-600/20 border-purple-500'
            : 'bg-gray-800/50 border-gray-700 hover:border-gray-600'
        ]"
        @click="$emit('update:modelValue', null)">
        <div
          class="flex justify-center items-center bg-gray-700 rounded-lg size-10 shrink-0">
          <fa-icon :icon="['fas', 'globe']" class="text-gray-400" />
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium text-white">Public Review</p>
          <p class="text-xs text-gray-500">Visible on your profile</p>
        </div>
        <fa-icon
          v-if="!modelValue"
          :icon="['fas', 'check-circle']"
          class="text-purple-400 shrink-0" />
      </button>

      <!-- Club options -->
      <button
        v-for="club in userClubs"
        :key="club.id"
        type="button"
        :class="[
          'w-full flex items-center gap-3 p-3 rounded-lg border transition-colors text-left',
          modelValue === club.id
            ? 'bg-purple-600/20 border-purple-500'
            : 'bg-gray-800/50 border-gray-700 hover:border-gray-600'
        ]"
        @click="$emit('update:modelValue', club.id)">
        <div class="overflow-hidden bg-gray-700 rounded-lg size-10 shrink-0">
          <img
            v-if="club.cover_url"
            :src="club.cover_url"
            :alt="club.name"
            class="object-cover size-full" />
          <div v-else class="flex justify-center items-center size-full">
            <fa-icon :icon="['fas', 'users']" class="text-gray-400" />
          </div>
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium text-white truncate">{{ club.name }}</p>
          <p class="text-xs text-gray-500">
            {{ club.member_count }}
            {{ club.member_count === 1 ? 'member' : 'members' }}
          </p>
        </div>
        <fa-icon
          v-if="modelValue === club.id"
          :icon="['fas', 'check-circle']"
          class="text-purple-400 shrink-0" />
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useStoreClubs } from '@/stores/storeClubs'
import { useStoreProfile } from '@/stores/storeProfile'

defineProps({
  modelValue: {
    type: String,
    default: null
  }
})

defineEmits(['update:modelValue'])

const storeClubs = useStoreClubs()
const storeProfile = useStoreProfile()

// Only show clubs if user has clubs enabled
const userProfile = computed(() => storeProfile.getCurrentUserProfile)
const clubsEnabled = computed(() => userProfile.value?.clubs_enabled)

// User's clubs they can share to
const userClubs = computed(() => {
  if (!clubsEnabled.value) return []
  return storeClubs.myClubs || []
})

// Fetch clubs on mount if not already loaded
onMounted(() => {
  if (clubsEnabled.value && !storeClubs.myClubsLoaded) {
    storeClubs.fetchMyClubs()
  }
})
</script>
